// Wybór zespołu (lider + współpracownicy) dla zadań i wizyt.
// W trybie AJAX wysyła stan po zamknięciu listy, nie po każdym kliknięciu —
// inaczej dodanie trzech osób to trzy żądania i trzy komplety powiadomień.
export default function assigneePicker({ options, selected, lead, endpoint }) {
    return {
        options,
        selected: [...selected],
        lead,
        endpoint,
        search: '',
        open: false,
        dirty: false,
        saving: false,
        // Ostatni skład potwierdzony przez serwer — do niego wracamy po błędzie.
        confirmed: { selected: [...selected], lead },

        init() {
            this.$watch('open', (isOpen) => {
                if (!isOpen && this.dirty) {
                    if (this.endpoint) {
                        this.persist()
                    } else {
                        // Tryb formularzowy: ukryte pola są już zaktualizowane.
                        // Zapisujemy TYLKO formularze oznaczone jako auto-submit —
                        // inaczej picker w formularzu dodania zadania wysyłałby
                        // niedokończony formularz przy każdym zamknięciu listy.
                        this.dirty = false
                        this.$el.closest('form.auto-submit-form')?.requestSubmit()
                    }
                }
            })
        },

        nameOf(id) {
            return this.options.find((o) => o.id === id)?.name ?? ''
        },

        filtered() {
            const needle = this.search.trim().toLowerCase()
            if (!needle) return this.options
            return this.options.filter((o) => o.name.toLowerCase().includes(needle))
        },

        toggle(id) {
            if (this.selected.includes(id)) {
                this.selected = this.selected.filter((x) => x !== id)
                if (this.lead === id) this.lead = this.selected[0] ?? null
            } else {
                this.selected.push(id)
                if (this.lead === null) this.lead = id
            }
            this.dirty = true
        },

        setLead(id) {
            if (!this.selected.includes(id)) return
            this.lead = id
            this.dirty = true
        },

        async persist() {
            // Strażnik: użytkownik zdąży otworzyć i zamknąć listę ponownie, zanim
            // poprzednie żądanie wróci. Bez tego backend dostałby dwa pełne zapisy
            // i wysłał dwa komplety powiadomień — dokładnie to, czego unikamy
            // wysyłając dopiero po zamknięciu listy.
            if (this.saving) return

            this.saving = true
            this.dirty = false

            // Zapamiętujemy dokładnie to, co wysyłamy. Po `await` pola
            // this.selected/this.lead mogą już opisywać NOWSZY wybór użytkownika
            // (edytował w trakcie lotu żądania), a serwer potwierdził przecież
            // tę wersję, nie tamtą. Odczytanie stanu żywego po powrocie
            // zapisałoby jako "potwierdzony" skład, którego backend nie widział.
            const payload = { selected: [...this.selected], lead: this.lead }

            try {
                const response = await fetch(this.endpoint, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json',
                        'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
                    },
                    body: JSON.stringify({ user_ids: payload.selected, lead_user_id: payload.lead }),
                })
                const data = await response.json()

                if (!response.ok || !data.success) {
                    throw new Error(data.message || 'Nie udało się zapisać przypisania.')
                }

                this.confirmed = payload
                this.$dispatch('assignees-updated', { endpoint: this.endpoint, assignees: data.assignees })
            } catch (error) {
                // Wracamy do ostatniego stanu potwierdzonego przez serwer.
                // Zostawienie chipów, których backend nie zapisał, jest gorsze niż
                // cofnięcie wyboru: użytkownik nie miałby jak zauważyć różnicy.
                // Powrót listy do poprzedniego składu JEST komunikatem — modal
                // tylko go tłumaczy.
                this.selected = [...this.confirmed.selected]
                this.lead = this.confirmed.lead
                console.error('[assignee-picker]', error)
                window.showError?.('Nie udało się zapisać przypisania', error.message)
            } finally {
                this.saving = false
                // Zmiana zrobiona w trakcie lotu poprzedniego żądania.
                if (this.dirty) this.persist()
            }
        },
    }
}
